import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './modalPopup.module.scss';

export default function ModalPopup({
  isOpen = false,
  onClose = () => {},
  children,
}) {
  const modalContentRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        modalContentRef.current &&
        !modalContentRef.current.contains(event.target)
      ) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [modalContentRef, onClose]);

  const closeIcon = (
    <div className={styles.modalPopupClose}>
      <div
        data-testid="close-icon"
        aria-label="Close"
        className={styles.modalPopupClosebtn}
        onClick={onClose}
        onKeyDown={onClose}
        role="button"
        tabIndex="0"
      />
    </div>
  );

  return isOpen ? (
    <div className={styles.modalPopup}>
      <div className={styles.modalPopupWrapper}>
        <div className={styles.modalPopupContents} ref={modalContentRef}>
          {children}
          {closeIcon}
        </div>
      </div>
    </div>
  ) : null;
}

ModalPopup.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};
